package net.frozenbit.games.soundgame.theme

import androidx.compose.material3.lightColorScheme
import androidx.compose.ui.graphics.Color

object Colors {
    object Host {
        val containerBackground = Color.White
        val containerForeground = Color.Black
        val containerForegroundMuted = containerForeground.copy(alpha = 0.5f)

        val primary = primaryLight
    }
}

// Material ----------
val primaryLight = Color(0xFF4B6700)
val onPrimaryLight = Color(0xFFFFFFFF)
val primaryContainerLight = Color(0xFF95C614)
val onPrimaryContainerLight = Color(0xFF384E00)
val secondaryLight = Color(0xFF50661E)
val onSecondaryLight = Color(0xFFFFFFFF)
val secondaryContainerLight = Color(0xFFD2ED95)
val onSecondaryContainerLight = Color(0xFF566C24)
val tertiaryLight = Color(0xFF006D31)
val onTertiaryLight = Color(0xFFFFFFFF)
val tertiaryContainerLight = Color(0xFF26D169)
val onTertiaryContainerLight = Color(0xFF005424)
val errorLight = Color(0xFFBA1A1A)
val onErrorLight = Color(0xFFFFFFFF)
val errorContainerLight = Color(0xFFFFDAD6)
val onErrorContainerLight = Color(0xFF93000A)
val backgroundLight = Color(0xFFF9FBE8)
val onBackgroundLight = Color(0xFF1A1D12)
val surfaceLight = Color(0xFFF9FBE8)
val onSurfaceLight = Color(0xFF1A1D12)
val surfaceVariantLight = Color(0xFFE0E5CB)
val onSurfaceVariantLight = Color(0xFF434936)
val outlineLight = Color(0xFF747A63)
val outlineVariantLight = Color(0xFFC3C9B0)
val scrimLight = Color(0xFF000000)
val inverseSurfaceLight = Color(0xFF2E3226)
val inverseOnSurfaceLight = Color(0xFFF0F2E0)
val inversePrimaryLight = Color(0xFFA5D72B)
val surfaceDimLight = Color(0xFFD9DCCA)
val surfaceBrightLight = Color(0xFFF9FBE8)
val surfaceContainerLowestLight = Color(0xFFFFFFFF)
val surfaceContainerLowLight = Color(0xFFF3F5E3)
val surfaceContainerLight = Color(0xFFEDEFDD)
val surfaceContainerHighLight = Color(0xFFE7EAD8)
val surfaceContainerHighestLight = Color(0xFFE2E4D2)

val primaryLightMediumContrast = Color(0xFF2A3C00)
val onPrimaryLightMediumContrast = Color(0xFFFFFFFF)
val primaryContainerLightMediumContrast = Color(0xFF587700)
val onPrimaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val secondaryLightMediumContrast = Color(0xFF2A3C00)
val onSecondaryLightMediumContrast = Color(0xFFFFFFFF)
val secondaryContainerLightMediumContrast = Color(0xFF5E752C)
val onSecondaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val tertiaryLightMediumContrast = Color(0xFF00401A)
val onTertiaryLightMediumContrast = Color(0xFFFFFFFF)
val tertiaryContainerLightMediumContrast = Color(0xFF007E3A)
val onTertiaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val errorLightMediumContrast = Color(0xFF740006)
val onErrorLightMediumContrast = Color(0xFFFFFFFF)
val errorContainerLightMediumContrast = Color(0xFFCF2C27)
val onErrorContainerLightMediumContrast = Color(0xFFFFFFFF)
val backgroundLightMediumContrast = Color(0xFFF9FBE8)
val onBackgroundLightMediumContrast = Color(0xFF1A1D12)
val surfaceLightMediumContrast = Color(0xFFF9FBE8)
val onSurfaceLightMediumContrast = Color(0xFF0F1208)
val surfaceVariantLightMediumContrast = Color(0xFFE0E5CB)
val onSurfaceVariantLightMediumContrast = Color(0xFF333826)
val outlineLightMediumContrast = Color(0xFF4F5541)
val outlineVariantLightMediumContrast = Color(0xFF6A705A)
val scrimLightMediumContrast = Color(0xFF000000)
val inverseSurfaceLightMediumContrast = Color(0xFF2E3226)
val inverseOnSurfaceLightMediumContrast = Color(0xFFF0F2E0)
val inversePrimaryLightMediumContrast = Color(0xFFA5D72B)
val surfaceDimLightMediumContrast = Color(0xFFC5C8B7)
val surfaceBrightLightMediumContrast = Color(0xFFF9FBE8)
val surfaceContainerLowestLightMediumContrast = Color(0xFFFFFFFF)
val surfaceContainerLowLightMediumContrast = Color(0xFFF3F5E3)
val surfaceContainerLightMediumContrast = Color(0xFFE7EAD8)
val surfaceContainerHighLightMediumContrast = Color(0xFFDCDECD)
val surfaceContainerHighestLightMediumContrast = Color(0xFFD1D3C2)

val primaryLightHighContrast = Color(0xFF223100)
val onPrimaryLightHighContrast = Color(0xFFFFFFFF)
val primaryContainerLightHighContrast = Color(0xFF3A5000)
val onPrimaryContainerLightHighContrast = Color(0xFFFFFFFF)
val secondaryLightHighContrast = Color(0xFF223100)
val onSecondaryLightHighContrast = Color(0xFFFFFFFF)
val secondaryContainerLightHighContrast = Color(0xFF3B5008)
val onSecondaryContainerLightHighContrast = Color(0xFFFFFFFF)
val tertiaryLightHighContrast = Color(0xFF003414)
val onTertiaryLightHighContrast = Color(0xFFFFFFFF)
val tertiaryContainerLightHighContrast = Color(0xFF005525)
val onTertiaryContainerLightHighContrast = Color(0xFFFFFFFF)
val errorLightHighContrast = Color(0xFF600004)
val onErrorLightHighContrast = Color(0xFFFFFFFF)
val errorContainerLightHighContrast = Color(0xFF98000A)
val onErrorContainerLightHighContrast = Color(0xFFFFFFFF)
val backgroundLightHighContrast = Color(0xFFF9FBE8)
val onBackgroundLightHighContrast = Color(0xFF1A1D12)
val surfaceLightHighContrast = Color(0xFFF9FBE8)
val onSurfaceLightHighContrast = Color(0xFF000000)
val surfaceVariantLightHighContrast = Color(0xFFE0E5CB)
val onSurfaceVariantLightHighContrast = Color(0xFF000000)
val outlineLightHighContrast = Color(0xFF292E1D)
val outlineVariantLightHighContrast = Color(0xFF464B38)
val scrimLightHighContrast = Color(0xFF000000)
val inverseSurfaceLightHighContrast = Color(0xFF2E3226)
val inverseOnSurfaceLightHighContrast = Color(0xFFFFFFFF)
val inversePrimaryLightHighContrast = Color(0xFFA5D72B)
val surfaceDimLightHighContrast = Color(0xFFB8BAA9)
val surfaceBrightLightHighContrast = Color(0xFFF9FBE8)
val surfaceContainerLowestLightHighContrast = Color(0xFFFFFFFF)
val surfaceContainerLowLightHighContrast = Color(0xFFF0F2E0)
val surfaceContainerLightHighContrast = Color(0xFFE2E4D2)
val surfaceContainerHighLightHighContrast = Color(0xFFD3D6C4)
val surfaceContainerHighestLightHighContrast = Color(0xFFC5C8B7)

val primaryDark = Color(0xFFB0E337)
val onPrimaryDark = Color(0xFF253500)
val primaryContainerDark = Color(0xFF95C614)
val onPrimaryContainerDark = Color(0xFF384E00)
val secondaryDark = Color(0xFFB6D07C)
val onSecondaryDark = Color(0xFF253500)
val secondaryContainerDark = Color(0xFF3B5008)
val onSecondaryContainerDark = Color(0xFFA8C26F)
val tertiaryDark = Color(0xFF4FEE82)
val onTertiaryDark = Color(0xFF003916)
val tertiaryContainerDark = Color(0xFF26D169)
val onTertiaryContainerDark = Color(0xFF005424)
val errorDark = Color(0xFFFFB4AB)
val onErrorDark = Color(0xFF690005)
val errorContainerDark = Color(0xFF93000A)
val onErrorContainerDark = Color(0xFFFFDAD6)
val backgroundDark = Color(0xFF11150A)
val onBackgroundDark = Color(0xFFE2E4D2)
val surfaceDark = Color(0xFF11150A)
val onSurfaceDark = Color(0xFFE2E4D2)
val surfaceVariantDark = Color(0xFF434936)
val onSurfaceVariantDark = Color(0xFFC3C9B0)
val outlineDark = Color(0xFF8D937C)
val outlineVariantDark = Color(0xFF434936)
val scrimDark = Color(0xFF000000)
val inverseSurfaceDark = Color(0xFFE2E4D2)
val inverseOnSurfaceDark = Color(0xFF2E3226)
val inversePrimaryDark = Color(0xFF4B6700)
val surfaceDimDark = Color(0xFF11150A)
val surfaceBrightDark = Color(0xFF373B2E)
val surfaceContainerLowestDark = Color(0xFF0C0F06)
val surfaceContainerLowDark = Color(0xFF1A1D12)
val surfaceContainerDark = Color(0xFF1E2116)
val surfaceContainerHighDark = Color(0xFF282B20)
val surfaceContainerHighestDark = Color(0xFF33362A)

val primaryDarkMediumContrast = Color(0xFFBAEE42)
val onPrimaryDarkMediumContrast = Color(0xFF1D2A00)
val primaryContainerDarkMediumContrast = Color(0xFF95C614)
val onPrimaryContainerDarkMediumContrast = Color(0xFF202F00)
val secondaryDarkMediumContrast = Color(0xFFCBE790)
val onSecondaryDarkMediumContrast = Color(0xFF1D2A00)
val secondaryContainerDarkMediumContrast = Color(0xFF81994C)
val onSecondaryContainerDarkMediumContrast = Color(0xFF000000)
val tertiaryDarkMediumContrast = Color(0xFF5BF98B)
val onTertiaryDarkMediumContrast = Color(0xFF002D10)
val tertiaryContainerDarkMediumContrast = Color(0xFF26D169)
val onTertiaryContainerDarkMediumContrast = Color(0xFF003213)
val errorDarkMediumContrast = Color(0xFFFFD2CC)
val onErrorDarkMediumContrast = Color(0xFF540003)
val errorContainerDarkMediumContrast = Color(0xFFFF5449)
val onErrorContainerDarkMediumContrast = Color(0xFF000000)
val backgroundDarkMediumContrast = Color(0xFF11150A)
val onBackgroundDarkMediumContrast = Color(0xFFE2E4D2)
val surfaceDarkMediumContrast = Color(0xFF11150A)
val onSurfaceDarkMediumContrast = Color(0xFFFFFFFF)
val surfaceVariantDarkMediumContrast = Color(0xFF434936)
val onSurfaceVariantDarkMediumContrast = Color(0xFFD9DFC5)
val outlineDarkMediumContrast = Color(0xFFAFB59C)
val outlineVariantDarkMediumContrast = Color(0xFF8D937C)
val scrimDarkMediumContrast = Color(0xFF000000)
val inverseSurfaceDarkMediumContrast = Color(0xFFE2E4D2)
val inverseOnSurfaceDarkMediumContrast = Color(0xFF282B20)
val inversePrimaryDarkMediumContrast = Color(0xFF394F00)
val surfaceDimDarkMediumContrast = Color(0xFF11150A)
val surfaceBrightDarkMediumContrast = Color(0xFF434639)
val surfaceContainerLowestDarkMediumContrast = Color(0xFF060802)
val surfaceContainerLowDarkMediumContrast = Color(0xFF1C1F14)
val surfaceContainerDarkMediumContrast = Color(0xFF26291E)
val surfaceContainerHighDarkMediumContrast = Color(0xFF313428)
val surfaceContainerHighestDarkMediumContrast = Color(0xFF3C3F32)

val primaryDarkHighContrast = Color(0xFFD5FF79)
val onPrimaryDarkHighContrast = Color(0xFF000000)
val primaryContainerDarkHighContrast = Color(0xFFA1D326)
val onPrimaryContainerDarkHighContrast = Color(0xFF070D00)
val secondaryDarkHighContrast = Color(0xFFDFFBA2)
val onSecondaryDarkHighContrast = Color(0xFF000000)
val secondaryContainerDarkHighContrast = Color(0xFFB2CC79)
val onSecondaryContainerDarkHighContrast = Color(0xFF070D00)
val tertiaryDarkHighContrast = Color(0xFFC1FFC7)
val onTertiaryDarkHighContrast = Color(0xFF000000)
val tertiaryContainerDarkHighContrast = Color(0xFF3ADE74)
val onTertiaryContainerDarkHighContrast = Color(0xFF000F03)
val errorDarkHighContrast = Color(0xFFFFECE9)
val onErrorDarkHighContrast = Color(0xFF000000)
val errorContainerDarkHighContrast = Color(0xFFFFAEA4)
val onErrorContainerDarkHighContrast = Color(0xFF220001)
val backgroundDarkHighContrast = Color(0xFF11150A)
val onBackgroundDarkHighContrast = Color(0xFFE2E4D2)
val surfaceDarkHighContrast = Color(0xFF11150A)
val onSurfaceDarkHighContrast = Color(0xFFFFFFFF)
val surfaceVariantDarkHighContrast = Color(0xFF434936)
val onSurfaceVariantDarkHighContrast = Color(0xFFFFFFFF)
val outlineDarkHighContrast = Color(0xFFEDF3D8)
val outlineVariantDarkHighContrast = Color(0xFFC0C5AC)
val scrimDarkHighContrast = Color(0xFF000000)
val inverseSurfaceDarkHighContrast = Color(0xFFE2E4D2)
val inverseOnSurfaceDarkHighContrast = Color(0xFF000000)
val inversePrimaryDarkHighContrast = Color(0xFF394F00)
val surfaceDimDarkHighContrast = Color(0xFF11150A)
val surfaceBrightDarkHighContrast = Color(0xFF4E5244)
val surfaceContainerLowestDarkHighContrast = Color(0xFF000000)
val surfaceContainerLowDarkHighContrast = Color(0xFF1E2116)
val surfaceContainerDarkHighContrast = Color(0xFF2E3226)
val surfaceContainerHighDarkHighContrast = Color(0xFF393D30)
val surfaceContainerHighestDarkHighContrast = Color(0xFF45483B)

internal val lightScheme = lightColorScheme(
    primary = primaryLight,
    onPrimary = onPrimaryLight,
    primaryContainer = primaryContainerLight,
    onPrimaryContainer = onPrimaryContainerLight,
    secondary = secondaryLight,
    onSecondary = onSecondaryLight,
    secondaryContainer = secondaryContainerLight,
    onSecondaryContainer = onSecondaryContainerLight,
    tertiary = tertiaryLight,
    onTertiary = onTertiaryLight,
    tertiaryContainer = tertiaryContainerLight,
    onTertiaryContainer = onTertiaryContainerLight,
    error = errorLight,
    onError = onErrorLight,
    errorContainer = errorContainerLight,
    onErrorContainer = onErrorContainerLight,
    background = backgroundLight,
    onBackground = onBackgroundLight,
    surface = surfaceLight,
    onSurface = onSurfaceLight,
    surfaceVariant = surfaceVariantLight,
    onSurfaceVariant = onSurfaceVariantLight,
    outline = outlineLight,
    outlineVariant = outlineVariantLight,
    scrim = scrimLight,
    inverseSurface = inverseSurfaceLight,
    inverseOnSurface = inverseOnSurfaceLight,
    inversePrimary = inversePrimaryLight,
    surfaceDim = surfaceDimLight,
    surfaceBright = surfaceBrightLight,
    surfaceContainerLowest = surfaceContainerLowestLight,
    surfaceContainerLow = surfaceContainerLowLight,
    surfaceContainer = surfaceContainerLight,
    surfaceContainerHigh = surfaceContainerHighLight,
    surfaceContainerHighest = surfaceContainerHighestLight,
)